var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "speakToStudent",
      class:
        _vm.calling === 0
          ? "speakToStudentAn"
          : _vm.calling === 1 || _vm.calling === 2
          ? "speakToStudentCl"
          : "",
      attrs: { id: "speakToStudent" }
    },
    [
      _c(
        "div",
        {
          staticClass: "speakBox",
          class: _vm.calling === 1 || _vm.calling === 2 ? "speakBoxAn" : ""
        },
        [
          _c("img", {
            staticClass: "callingImg",
            attrs: {
              src:
                _vm.calling !== 2
                  ? "https://img.webloom.cn/img/callPhone.png"
                  : "https://img.webloom.cn/img/stopCall.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "speakText" }, [
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    _vm.calling === 0
                      ? "speakToStudent.willSpeak"
                      : _vm.calling === 1
                      ? "speakToStudent.connecting"
                      : _vm.calling === 2
                      ? "speakToStudent.hangUp"
                      : ""
                  )
                )
              )
            ]),
            _vm._v(" "),
            _vm.calling === 0
              ? _c("div", { staticClass: "times" }, [
                  _vm._v(_vm._s(_vm.time) + "s")
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        attrs: { id: "audioSpeakToStudent" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-69543708", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-69543708","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/bloom-proctor/public/speakToStudent.vue
// module id = null
// module chunks = 